import { openingHours, soleActiveBranch } from "@1-now/booking-core";

/**
 * The opening hours the footer states (1NOW-11175), as lines ("Mon – Fri: 8:00 AM – 8:00 PM").
 *
 * Only for a company with one active branch that states its own hours: with several branches
 * there is no single answer to print, and a branch that states nothing would fall through to
 * the company's flag (a degenerate 00:00-00:00 window reads as "Open 24 hours", which is not
 * a claim a footer should make on its own). Nothing to say is an empty list, and the footer
 * draws no row.
 */
const statesHours = (branch: any): boolean => {
  const week = branch?.weekly_hours;
  if (week && typeof week === "object" && !Array.isArray(week) && Object.keys(week).length > 0) return true;
  return !!(branch?.operational_start_time && branch?.operational_end_time);
};

export const footerHours = (locations: any[] | null | undefined, company: any): string[] => {
  const branch = soleActiveBranch(locations);
  if (!branch || !statesHours(branch)) return [];
  return openingHours(branch, company)?.lines ?? [];
};
